const { protocol } = window.location;

export const AUTH_API_CONFIG = {
  API_SERVER_SCHEMA: protocol,
  API_SERVER_HOST: import.meta.env.VITE_AUTH_API_HOST,
  API_NAME: import.meta.env.VITE_AUTH_API_APP_NAME!,
};

export const DICTIONARY_API_CONFIG = {
  API_SERVER_SCHEMA: protocol,
  API_SERVER_HOST: import.meta.env.VITE_DICTIONARY_API_HOST,
  API_NAME: import.meta.env.VITE_DICTIONARY_API_APP_NAME!,
};

export const ROUTE_API_CONFIG = {
  API_SERVER_SCHEMA: protocol,
  API_SERVER_HOST: import.meta.env.VITE_ROUTE_API_HOST,
  API_NAME: import.meta.env.VITE_ROUTE_API_APP_NAME!,
};

export const BACK_OFFICE_API_CONFIG = {
  API_SERVER_SCHEMA: protocol,
  API_SERVER_HOST: import.meta.env.VITE_BACK_OFFICE_API_HOST,
  API_NAME: import.meta.env.VITE_BACK_OFFICE_API_APP_NAME!,
};

export const CHAT_API_CONFIG = {
  API_SERVER_SCHEMA: protocol,
  API_SERVER_HOST: import.meta.env.VITE_CHAT_API_HOST,
  API_NAME: import.meta.env.VITE_CHAT_API_APP_NAME!,
};

export const DOC_API_CONFIG = {
  API_SERVER_SCHEMA: protocol,
  API_SERVER_HOST: import.meta.env.VITE_DOC_API_HOST,
  API_NAME: import.meta.env.VITE_DOC_API_APP_NAME!,
};

export const NOTIFICATION_API_CONFIG = {
  API_SERVER_SCHEMA: protocol,
  API_SERVER_HOST: import.meta.env.VITE_NOTIFICATION_API_HOST,
  API_NAME: import.meta.env.VITE_NOTIFICATION_API_APP_NAME!,
};

export const AUDIT_API_CONFIG = {
  API_SERVER_SCHEMA: protocol,
  API_SERVER_HOST: import.meta.env.VITE_AUDIT_API_HOST,
  API_NAME: import.meta.env.VITE_AUDIT_API_APP_NAME!,
};

export const AI_API_CONFIG = {
  API_SERVER_SCHEMA: protocol,
  API_SERVER_HOST: import.meta.env.VITE_AI_API_HOST,
  API_NAME: import.meta.env.VITE_AI_API_APP_NAME!,
};
